/* The HTML keeps every coordinate/report usable even when the map is unavailable. */
(() => {
  'use strict';
  const root=document.getElementById('pt-places');if(!root)return;
  const regions=JSON.parse(root.querySelector('[data-ptp-data]').textContent);
  const canvas=root.querySelector('#ptp-map'),status=root.querySelector('[data-ptp-map-status]');
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  let map=null,group=null,loading=null,selected='all',pendingPoint=null;
  const markers=new Map();
  function select(code,scroll=false,point=null){
    if(code!=='all'&&!regions.some(r=>r.id===code))return;
    selected=code;pendingPoint=point;
    root.querySelectorAll('[data-ptp-select]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.ptpSelect===code)));
    const region=regions.find(r=>r.id===code);
    root.querySelector('[data-ptp-selected]').textContent=region?region.title:'Alle dokumentierten Pflanzflächen';
    root.querySelector('[data-ptp-map-copy]').textContent=region?region.points.length+' dokumentierte Pflanzflächen · '+(region.paused?'Frühere Pflanzungen, aktuell nicht wählbar.':'Diese Region kannst du für dein Baumgeschenk wählen.'):'Wähle eine Region oder einen Punkt auf der Karte. Auch frühere Pflanzungen bleiben sichtbar.';
    if(map)render();else loadMap();
    if(scroll){canvas.scrollIntoView({behavior:reduced.matches?'auto':'smooth',block:'center'});canvas.focus({preventScroll:true});}
  }
  function render(){
    if(!map)return;
    group.clearLayers();markers.clear();const points=[];
    regions.filter(r=>selected==='all'||r.id===selected).forEach(region=>region.points.forEach((p,index)=>{
      const popup=document.createElement('div'),title=document.createElement('strong'),coords=document.createElement('p'),link=document.createElement('a');
      title.textContent=region.title+' · '+p.name;coords.textContent=p.dms;link.textContent='Pflanzflächen und Berichte ansehen';link.href='#'+region.id;
      popup.append(title,coords,link);
      const marker=L.circleMarker([p.lat,p.lon],{radius:8,weight:2,color:'#fff5df',fillColor:region.paused?'#8f7750':'#315c3c',fillOpacity:1}).addTo(group).bindPopup(popup);
      points.push([p.lat,p.lon]);markers.set(region.id+'-'+index,marker);
    }));
    map.invalidateSize();
    if(pendingPoint){const marker=markers.get(pendingPoint);if(marker){map.setView(marker.getLatLng(),14,{animate:!reduced.matches});marker.openPopup();}pendingPoint=null;}
    else if(points.length)map.fitBounds(points,{padding:[32,32],maxZoom:12,animate:!reduced.matches});
  }
  function loadMap(){
    if(loading)return loading;
    status.textContent='Karte wird geladen …';status.hidden=false;
    loading=new Promise((resolve,reject)=>{
      if(window.L){resolve();return;}
      const css=document.createElement('link');css.rel='stylesheet';css.href='https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';document.head.append(css);
      const script=document.createElement('script');script.src='https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';script.onload=resolve;script.onerror=reject;document.head.append(script);
    }).then(()=>{
      map=L.map(canvas,{scrollWheelZoom:false,dragging:!matchMedia('(pointer:coarse)').matches,tap:false});
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{maxZoom:18,attribution:'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>-Mitwirkende'}).on('tileload',()=>{status.hidden=true;}).addTo(map);
      group=L.featureGroup().addTo(map);render();
      if('ResizeObserver' in window)new ResizeObserver(()=>map.invalidateSize()).observe(canvas);
    }).catch(()=>{loading=null;status.textContent='Die Karte ist gerade nicht verfügbar. Alle Pflanzflächen und Koordinaten findest du weiter unten.';});
    return loading;
  }
  root.addEventListener('click',event=>{
    const selectButton=event.target.closest('[data-ptp-select]');if(selectButton){select(selectButton.dataset.ptpSelect);return;}
    const point=event.target.closest('[data-ptp-point]');if(point){select(point.dataset.ptpRegion,true,point.dataset.ptpPoint);return;}
    const copy=event.target.closest('[data-ptp-copy]');if(copy){
      if(navigator.clipboard?.writeText)navigator.clipboard.writeText(copy.dataset.ptpCopy).then(()=>{copy.textContent='Kopiert ✓';}).catch(()=>{copy.textContent='Bitte Koordinaten markieren und kopieren';});
      else copy.textContent='Bitte Koordinaten markieren und kopieren';
    }
  });
  if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){observer.disconnect();loadMap();}},{rootMargin:'250px'});observer.observe(canvas);}else loadMap();
})();
